var map = {
	"./CategoriesOverview": "XNJi",
	"./CategoriesOverview.js": "XNJi",
	"./CategoryPatterns": "Y2YK",
	"./CategoryPatterns.js": "Y2YK",
	"./ColorSwatchesCartForm": "iSCd",
	"./ColorSwatchesCartForm.js": "iSCd",
	"./DesignerGallery": "ESsZ",
	"./DesignerGallery.js": "ESsZ",
	"./ExternalLink": "6mzq",
	"./ExternalLink.js": "6mzq",
	"./Fabrics": "xAT9",
	"./Fabrics.js": "xAT9",
	"./FavoritesGallery": "5bKB",
	"./FavoritesGallery.js": "5bKB",
	"./Hashtag": "xFfy",
	"./Hashtag.js": "xFfy",
	"./Header": "O2nu",
	"./Header.js": "O2nu",
	"./Heading": "4/2G",
	"./Heading.js": "4/2G",
	"./Home": "FYqW",
	"./Home.js": "FYqW",
	"./LinearProgress": "jZGx",
	"./LinearProgress.js": "jZGx",
	"./Logo": "5+D9",
	"./Logo.js": "5+D9",
	"./LogoQ": "lJWF",
	"./LogoQ.js": "lJWF",
	"./NewsletterForm": "rss6",
	"./NewsletterForm.js": "rss6",
	"./NewsletterSubscribed": "Qe2F",
	"./NewsletterSubscribed.js": "Qe2F",
	"./PatternGalleries": "8L6y",
	"./PatternGalleries.js": "8L6y",
	"./PatternRepeat": "Dy6C",
	"./PatternRepeat.js": "Dy6C",
	"./PatterngalleryNewest": "LXGs",
	"./PatterngalleryNewest.js": "LXGs",
	"./SearchResult": "1+Ik",
	"./SearchResult.js": "1+Ik",
	"./SewpatCard": "Je5D",
	"./SewpatCard.js": "Je5D",
	"./SewpatGalleries": "szLU",
	"./SewpatGalleries.js": "szLU",
	"./SewpatGallery": "jTE+",
	"./SewpatGallery.js": "jTE+",
	"./SinglePatternView": "pwTb",
	"./SinglePatternView.js": "pwTb",
	"./SingleSewpatView": "mQua",
	"./SingleSewpatView.js": "mQua",
	"./SubCategoryGallery": "FoP/",
	"./SubCategoryGallery.js": "FoP/",
	"./TopCategoriesGalleries": "jiVp",
	"./TopCategoriesGalleries.js": "jiVp",
	"./deAbout": "eNS2",
	"./deAbout.js": "eNS2",
	"./deImprint": "C8X8",
	"./deImprint.js": "C8X8",
	"./dePrivacy": "V+fu",
	"./dePrivacy.js": "V+fu",
	"./deShipping": "EgZD",
	"./deShipping.js": "EgZD",
	"./deTos": "4NqZ",
	"./deTos.js": "4NqZ",
	"./defaq-coloring-options": "9N07",
	"./defaq-coloring-options.js": "9N07",
	"./enAbout": "6HBO",
	"./enAbout.js": "6HBO",
	"./enImprint": "yqnL",
	"./enImprint.js": "yqnL",
	"./enPrivacy": "UU+7",
	"./enPrivacy.js": "UU+7",
	"./enShipping": "5mFl",
	"./enShipping.js": "5mFl",
	"./enTos": "dtML",
	"./enTos.js": "dtML",
	"./enfaq-coloring-options": "Ds/6",
	"./enfaq-coloring-options.js": "Ds/6"
};
function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id])
		throw new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
	return __webpack_require__(id);
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "hZ46";
module.exports = webpackContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/async weak ^\.\/.*$
// module id = hZ46
// module chunks = 58